import {Trans} from '@lingui/macro';
import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Link} from '../../../components/common/links/link';

/*
 * Props.
 */

interface UpsellWrapperProps {
  hasUpsell: boolean;
  upsellUrl: string;
  children: ReactNode;
  width?: string;
}

/*
 * Styles.
 */

const StyledRelativeWrapper = styled.div`
  position: relative;
`;

const UpsellWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  opacity: 0;
  transition: 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

const UpsellGradient = styled.div<{$width?: string}>`
  display: flex;
  align-items: flex-end;

  padding: 20px;

  border-radius: 16px;

  width: ${({$width}) => $width};
  height: 100%;
  background: linear-gradient(360deg, ${(p) => p.theme.greys.white} 10%, ${(p) => p.theme.greys.white} 60%);

  // Elements have a 1px border that the background should not hide
  border: 1px solid ${(p) => p.theme.greys.black};
  background-clip: padding-box;
`;

/*
 * Component.
 */

export const UpsellOverlay: FC<UpsellWrapperProps> = ({children, hasUpsell, upsellUrl, width}) => {
  if (!hasUpsell) {
    return <>{children}</>;
  }

  return (
    <StyledRelativeWrapper>
      {children}
      <UpsellWrapper>
        <UpsellGradient $width={width}>
          <Link to={upsellUrl}>
            <Button variant={ButtonVariantsEnum.SECONDARY}>
              <Trans id="rule-library-upsell-wrapper-button">Upgrade</Trans>
            </Button>
          </Link>
        </UpsellGradient>
      </UpsellWrapper>
    </StyledRelativeWrapper>
  );
};
